import { Injectable } from '@angular/core';
import { StoreConfig } from '@datorama/akita';
import { OrgUIModel } from '@y42/org/models';
import { Y42EntityStore } from '@y42/state';
import { OrgSpaceState, OrgSpaceStoreModel } from '../models/org-space.model';

const initialState: OrgSpaceState = {
  spacesByOrg: {},
  active: null,
};

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'org-space', idKey: 'id' })
export class OrgSpaceStore extends Y42EntityStore<OrgSpaceState> {
  constructor() {
    super(initialState);
  }

  upsertOrgSpacesMap(orgId: OrgUIModel['id'], spaces: OrgSpaceStoreModel[]): void {
    this.update((st) => {
      const spaceIds = st.spacesByOrg[orgId] || [];
      const newSpaceIds = spaces.map((space) => space.id);
      const newSpacesSet = new Set([...spaceIds, ...newSpaceIds]);
      const sortedSpaces = Array.from(newSpacesSet)
        .map((spaceId) => (st.entities || {})[spaceId])
        .sort((a, b) => a?.name.localeCompare(b?.name || '') || 0);

      const sortedSpaceIds = sortedSpaces
        .filter((space: OrgSpaceStoreModel | undefined): space is OrgSpaceStoreModel => !!space)
        .map((space) => space.id);

      return {
        ...st,
        spacesByOrg: {
          ...st.spacesByOrg,
          [orgId]: sortedSpaceIds,
        },
      };
    });
  }

  removeOrgSpacesMap(orgId: OrgUIModel['id'], spaceId: OrgSpaceStoreModel['id']): void {
    this.update((st) => {
      const spaceIds = st.spacesByOrg[orgId] || [];
      const newSpaceIds = spaceIds.filter((id) => spaceId !== id);

      return {
        ...st,
        spacesByOrg: {
          ...st.spacesByOrg,
          [orgId]: newSpaceIds,
        },
      };
    });
  }
}
